import React from "react";
import BoxComponent from "../../../components/Box/BoxComponent";
import TypographyComponent from "../../../components/Typography/ThypographyComponent";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import { formatNumberToDinheiro } from "../../../utils/dinheiro";
import { InfoPedidoProps } from "../PedidosPage";
import { calcularTempoMedio } from "../../../utils/datas";
import DetalhePedidoComponent from "./DetalhePedidoComponent";
import { removeCaracteresEspeciais } from "../../../utils/texto";
import { pedidoService } from "../../../service/PedidoService";

interface LayoutStyleProps {
    backgroundMainColor: string;
    color: string;
    backgroundCountColor?: string;
}

interface ListaPedidosProps {
    categoria: string;
    count?: number;
    style: LayoutStyleProps;
    infoPedidos?: InfoPedidoProps[]
    infoPedido?: InfoPedidoProps,
    onClickPedido: (id: number, element: InfoPedidoProps) => void;
    onClickConfirmacaoPedido: (id: number) => void;
    onClickCancelamentoPedido: (id: number) => void;
}

const ListaPedidosComponent = (props: ListaPedidosProps) => {
    const isDetalhesPedido = props.categoria === "Detalhes do pedido";

    const renderInfo = (props: ListaPedidosProps) => {
        if (props.categoria === "Detalhes do pedido") return <DetalhePedidoComponent 
            infoPedido={props.infoPedido} 
            onClick={(id: number) => props.onClickConfirmacaoPedido(id)}
            onClickCancelamentoPedido={(id: number) => props.onClickCancelamentoPedido(id)}
        />
        else return <>
            {props.infoPedidos && props.infoPedidos.map((element: InfoPedidoProps, index: number) => {
                const textoSemCaracteres = removeCaracteresEspeciais(element.status);
                const cores = pedidoService.getCoresPorStatus(textoSemCaracteres.toUpperCase());

                return <ButtonComponent
                    id={`pedido_${element.id}`}
                    key={`pedido_${element.id}`}
                    sx={{
                        // height: 132,
                        opacity: 1,
                        transform: 'rotate(0deg)',
                        display: 'flex',
                        flexDirection: "column",
                        gap: '8px',
                        padding: '12px',
                        borderRadius: '8px',
                        backgroundColor: ' #FFFFFF',
                        border: '2px solid  #E8DFD5',
                        boxSizing: 'border-box',
                        width: "100%"
                    }}
                    onClick={() => props.onClickPedido(element.id, element)}
                >
                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            width: "100%"
                        }}
                    >
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                flex: 1
                            }}
                        >
                            <TypographyComponent
                                variant="h3" fontWeight="bold"
                                sx={{
                                    fontFamily: '"Font 2", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    letterSpacing: '0em',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    color: '#3D2817',
                                    textTransform: 'none'
                                }}
                            >
                                {element.infoSolicitante.nome}
                            </TypographyComponent>
                            <TypographyComponent
                                variant="body2" fontWeight="bold"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 400,
                                    fontSize: '10.7px',
                                    lineHeight: '16px',
                                    letterSpacing: '0em',
                                    color: '#7A6B63',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    textTransform: 'none'
                                }}
                            >
                                {`#${element.id}`}
                            </TypographyComponent>
                        </BoxComponent>
                        <TypographyComponent
                            variant="body2" fontWeight="bold"
                            sx={{
                                fontFamily: '"Font 1", sans-serif',
                                fontWeight: 700,
                                fontSize: '11.3px',
                                lineHeight: '16px',
                                letterSpacing: '0em',
                                color: '#7A6B63',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle',
                                textTransform: 'none'
                            }}
                        >
                            {calcularTempoMedio(new Date(element.dataInicial), new Date())}
                        </TypographyComponent>
                    </BoxComponent>

                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%"
                        }}
                    >
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                flexDirection: "column"
                            }}
                        >
                            <BoxComponent
                                component="div"
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                    height: 26,
                                    opacity: 1,
                                    transform: 'rotate(0deg)',
                                    py: 1.2,
                                    px: 1.2,
                                    borderRadius: '33554400px',
                                    border: `1px solid ${cores.borderColor}`,
                                    boxSizing: 'border-box',
                                    background: cores.backgroundColor,
                                }}
                            >
                                <TypographyComponent
                                    variant="body2" fontWeight="bold"
                                    sx={{
                                        fontFamily: '"Font 2", sans-serif',
                                        fontWeight: 600,
                                        fontSize: '14px',
                                        lineHeight: '24px',
                                        letterSpacing: '0em',
                                        display: 'flex',
                                        alignItems: 'center',
                                        verticalAlign: 'middle',
                                        textTransform: 'none',
                                        color: cores.color,
                                    }}
                                >
                                    {element.status}
                                </TypographyComponent>
                            </BoxComponent>
                        </BoxComponent>
                        <TypographyComponent
                            variant="body2" fontWeight="bold"
                            sx={{
                                fontFamily: '"Font 1", sans-serif',
                                fontWeight: 700,
                                fontSize: '12.7px',
                                lineHeight: '20px',
                                letterSpacing: '0em',
                                color: '#FF8C42',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle',
                                textTransform: 'none'
                            }}
                        >
                            {formatNumberToDinheiro(element.valor)}
                        </TypographyComponent>
                    </BoxComponent>
                </ButtonComponent>
            })}
        </>
    }

    return <BoxComponent
        component="article"
        sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            flex: isDetalhesPedido ? 1 : 3,
            //backgroundColor: 'var(--color-white-solid, #FFFFFF)',
            borderRadius: '8px',
            borderTop: '1px solid var(--color-orange-87, #E8DFD5)',
            boxShadow: '0px 2px 8px 0px rgba(61, 40, 23, 0.08)',
            overflow: 'hidden',
            boxSizing: 'border-box',
            height: "100%"
        }}
    >
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                backgroundColor: props.style.backgroundMainColor,
                borderTopRadius: '8px',
                borderTop: '1px solid var(--color-orange-87, #E8DFD5)',
                boxShadow: '0px 2px 8px 0px rgba(61, 40, 23, 0.08)',
                overflow: 'hidden',
                boxSizing: 'border-box',
                padding: 2 // 16PX
            }}
        >
            <TypographyComponent
                variant="body2" fontWeight="bold"
                sx={{
                    fontFamily: '"Font 2", sans-serif',
                    fontWeight: 600,

                    fontSize: '16px',
                    lineHeight: '24px',
                    letterSpacing: '0em',

                    display: 'flex',
                    alignItems: 'center',
                    verticalAlign: 'middle',
                    textTransform: 'none',
                    color: props.style.color,
                }}
            >
                {props.categoria}
            </TypographyComponent>
            <TypographyComponent
                variant="body2" fontWeight="bold"
                sx={{
                    width: 26,
                    height: 26,
                    opacity: 1,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: '4px',
                    px: '10px',
                    borderRadius: '50%',
                    backgroundColor: props.style.backgroundCountColor,
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 700,
                    fontSize: '12px',
                    lineHeight: '16px',
                    color: props.style.color,
                    verticalAlign: 'middle',
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                }}
            >
                {props.count}
            </TypographyComponent>
        </BoxComponent>

        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: isDetalhesPedido ? "center" : "flex-start",
                alignItems: isDetalhesPedido ? "center" : "flex-start",
                flex: 2,
                backgroundColor: "#FFF",
                // borderRadius: '8px',
                // border: '1px solid var(--color-orange-87, #E8DFD5)',
                boxShadow: '0px 2px 8px 0px rgba(61, 40, 23, 0.08)',
                overflow: 'auto',
                boxSizing: 'border-box',
                width: "100%",
                padding: 2,
                gap: 1.2,
                height: "100%"
            }}
        >
            {renderInfo(props)}
        </BoxComponent>
    </BoxComponent >
}

export default ListaPedidosComponent;